import { render, staticRenderFns } from "./OnBoarding.vue?vue&type=template&id=3c49001d&"
import script from "./OnBoarding.vue?vue&type=script&lang=js&"
export * from "./OnBoarding.vue?vue&type=script&lang=js&"
import style0 from "./OnBoarding.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCardTitle,VStepper,VStepperContent,VStepperItems})
